import { GraphQLNonNull, GraphQLID } from 'graphql'
import { Context } from '../shared'
import { ContrastGraphQLFieldConfig } from '..'
import { SensitiveDataPolicy } from '../../../components/sensitive-data'
import { sensitiveDataPolicyType } from '../types/sensitive-data-types'

interface SensitiveDataPolicyQueryArgs {
  readonly organizationID: string
  readonly policyID: string
}

const sensitiveDataPolicyQueryArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  policyID: {
    description: 'The unique ID for the policy',
    type: new GraphQLNonNull(GraphQLID)
  }
}

export const sensitiveDataPolicy: ContrastGraphQLFieldConfig<
  any,
  Context,
  SensitiveDataPolicyQueryArgs,
  SensitiveDataPolicy
> = {
  description: 'Get sensitive data policies by organization ID',
  type: new GraphQLNonNull(sensitiveDataPolicyType),
  args: sensitiveDataPolicyQueryArgs,
  async resolve(_source, args, context) {
    const { organizationID, policyID } = args
    const { connector } = context
    const { policy } = await connector.get(
      `/${organizationID}/sensitivedata/policy/${policyID}`
    )
    const {
      id,
      name,
      group_id: groupID,
      default_keywords: keywords,
      is_required: required,
      is_enabled: enabled,
      is_default: isDefault,
      keywords: customKeywords
    } = policy

    return {
      id,
      name,
      groupID,
      keywords,
      required,
      enabled,
      isDefault,
      customKeywords
    }
  }
}
